const state = {
  loginRegisterStatus: false,
  // 当前状态 0 登录, 1 注册 , 2 扫码
  currentType: 'login',
  bindStatus: false,
  // 绑定的类型：微信： weChat, 支付宝： aliPay
  bindType: 'weChat'
}

const getters = {
  loginRegisterStatus: (state) => state.loginRegisterStatus,
  loginRegisterType: (state) => state.currentType,
  bindStatus: (state) => state.bindStatus,
  bindType: (state) => state.bindType
}

const mutations = {
  SET_LOGIN_REGISTER_STATUS(state, status) {
    state.loginRegisterStatus = status
  },
  SET_LOGIN_REGISTER_TYPE(state, status) {
    state.currentType = status
  },
  SET_BIND_TYPE(state, status) {
    state.bindType = status
  }
}

const actions = {
  setLoginRegisterStatus({ commit }, state) {
    commit('SET_LOGIN_REGISTER_STATUS', state)
  },
  setLoginRegisterType({ commit }, state) {
    const { loginState, loginType } = state
    commit('SET_LOGIN_REGISTER_STATUS', loginState)
    commit('SET_LOGIN_REGISTER_TYPE', loginType)
  },
  setBindType({ commit }, state) {
    commit('SET_BIND_TYPE', state)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
